import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className?: string;
  children?: React.ReactNode;
}

export const FilterListBar = styled.div<IProps>`
  height: 56px;
  position: relative;

  .area-left + .list {
    padding-left: 0;
  }

  @media ${({ theme }) => theme.media.smMax} {
    height: ${mixin.pxToVw('56')};
  }

  @media ${({ theme }) => theme.media.pc} {
    height: 62px;
    margin-bottom: 35.5px;
  }
`;

export const Box = styled.div<IProps>`
  width: 100%;
  height: inherit;
  background-color: #fff;
  ${mixin.flex({ justify: 'flex-start' })};
`;

export const Left = styled.span<IProps>`
  min-width: 58px;
  padding: 12px 6px 12px 20px;
  flex: none;
  z-index: 1;

  .btn {
    width: 32px;
    height: 32px;
    border: 1px solid #eee;
    border-radius: 30px;

    svg {
      width: 16px;
      height: 12px;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    min-width: ${mixin.pxToVw('58')};
    padding: ${mixin.pxToVw('12 6 12 20')};

    .btn {
      width: ${mixin.pxToVw('32')};
      height: ${mixin.pxToVw('32')};
      border-radius: ${mixin.pxToVw('30')};

      svg {
        width: ${mixin.pxToVw('16')};
        height: ${mixin.pxToVw('12')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 0px 10px 0px 0px;
    min-width: auto;
    z-index: 2;

    svg {
      width: 36px;
      height: 36px;
    }
  }
`;

export const List = styled.div<IProps>`
  padding: 2px 20px;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  overflow-y: hidden;
  overflow-x: auto;
  z-index: 1;
  overscroll-behavior: contain auto;

  &::-webkit-scrollbar {
    display: none;
  }

  .item {
    margin-left: 6px;

    &:first-child {
      margin-left: 0;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('0 20')};

    .item {
      margin-left: ${mixin.pxToVw('6')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 0;
    .item {
      &.type-close {
        .btn .text {
          display: block;
          max-width: 215px;
        }
      }
    }
  }
`;
